<template>
	<div>
		<a-layout>
			<a-layout-sider style="background: #FFFFFF;overflow: hidden; height: 100vh;" width="200px">
				<div style="padding: 30px 20px;">
					<div v-for="(item,index) in menus" :key="index" @click="goToUrl(index)" class="second-menu-item "
						:class="{on:getSelectKey.indexOf(item.key) > -1}">
						<i class="iconfont ft14" :class="item.icon"></i>
						<span class="ft14 ml10">{{item.name}}</span>
					</div>
				</div>
			</a-layout-sider>
			<a-layout-content style="padding: 30px 20px;height: 100vh; background: #F7F8FA;">
				<div>
					<router-view></router-view>
				</div>
			</a-layout-content>
		</a-layout>

	</div>
</template>

<script>
	export default {

		data() {
			return {
				showForm: false,
				menus: [
					{
						name: '治疗师管理',
						icon: 'iconappoint_tab02',
						key: 'appointment_index',
						link: '/appointment'
					},
					{
						name: '预约列表',
						icon: 'iconmall_order',
						key: 'appointment_order',
						link: '/appointment/order'
					},
					{
						name: '预约看板',
						icon: 'iconappoint_tab06',
						key: 'appointment_kanban',
						link: '/appointment/kanban'
					},
					{
						name: '预约设置',
						icon: 'iconappoint_tab10',
						key: 'appointment_shezhi',
						link: '/appointment/shezhi'
					},
					{
						name: '治疗师排班',
						icon: 'iconappoint_tab11',
						key: 'appointment_technician_scheduling',
						link: '/appointment/technicianScheduling'
					},
					// {
					// 	name: '业绩类型',
					// 	icon: 'iconappoint_tab12',
					// 	key: 'appointment_performance_type',
					// 	link: '/appointment/performanceType'
					// },
					// {
					// 	name: '业绩核准',
					// 	icon: 'iconappoint_tab08',
					// 	key: 'appointment_performance_approval',
					// 	link: '/appointment/performanceApproval'
					// },
					// {
					// 	name: '员工业绩',
					// 	icon: 'iconappoint_tab09',
					// 	key: 'appointment_employee_performance',
					// 	link: '/appointment/employeePerformance'
					// },
				]
			}
		},
		computed:{
			/*menus(){
				return [
					{
						name: this.artificer + '管理',
						icon: 'iconappoint_tab02',
						key: 'appointment_index',
						link: '/appointment'
					},
					{
						name: '预约列表',
						icon: 'iconmall_order',
						key: 'appointment_order',
						link: '/appointment/order'
					},
					{
						name: '预约看板',
						icon: 'iconappoint_tab06',
						key: 'appointment_kanban',
						link: '/appointment/kanban'
					},
					{
						name: '预约设置',
						icon: 'iconappoint_tab10',
						key: 'appointment_shezhi',
						link: '/appointment/shezhi'
					},
					{
						name: this.artificer + '排班',
						icon: 'iconappoint_tab11',
						key: 'appointment_technician_scheduling',
						link: '/appointment/technicianScheduling'
					},
					{
						name: '业绩类型',
						icon: 'iconappoint_tab12',
						key: 'appointment_performance_type',
						link: '/appointment/performanceType'
					},
					{
						name: '业绩核准',
						icon: 'iconappoint_tab08',
						key: 'appointment_performance_approval',
						link: '/appointment/performanceApproval'
					},
					{
						name: '员工业绩',
						icon: 'iconappoint_tab09',
						key: 'appointment_employee_performance',
						link: '/appointment/employeePerformance'
					},
				];
			}*/
		},
		created(){
			this.filterMenusByPermission();
		},
		methods: {
			filterMenusByPermission() {
				// 获取权限字符串
				const caidanStr = localStorage.getItem('beautiful-caidan');
				if(caidanStr == 'all'){
					return;
				}
				const allowedKeys = caidanStr.split(',');
				
				// 过滤菜单
				this.menus = this.menus.filter(menu => 
					allowedKeys.includes(menu.key)
				);
        	},
			goToUrl(index) {
				this.refreshPage(this.menus[index].link);
			},
		}
	}
</script>

<style>

</style>
